import React from "react";
import Modalpopup from '../../Shared/Modals/Modal';
import { saveStatusChecker } from '../../../store/Actions/Lender/saveStatusChecker/saveStatusChecker'
import { Modal, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import ConfirmationPopup from "../common/components/Modalpopups/ConfirmationPopup/ConfirmationPopup";

const SavestatusChecker = (props) => {
    const navigate = useNavigate();

    const saveChecker = () => {
        props.setShowModal(false);
        dispatch(saveStatusChecker(false));
        switch (props.Type) {
            case 'accountManagement':
                navigate('/Admin/AccountManagement');
                break;
            case 'Pipeline':
                props.PrimaryAction();
                navigate('/Admin/Pipeline');
                break;
            case 'navBar':
                props.PrimaryAction();
                navigate(props.item.route);
                break;
            case 'Header':
                props.PrimaryAction();
                break;
            default:
                break;
        }
    }
    const dispatch = useDispatch();
    return (
        <ConfirmationPopup
            showModal={props.showModal}
            onClose={() => props.setShowModal(false)}
            modalTitle='Save Changes'
            title='Changes you made on the Scorecard may not be saved.'
            primaryAction={() => saveChecker()}
            secondaryAction={() => props.setShowModal(false)}
            primaryActionLabel='Leave'
            secondaryActionLabel='Close'
        />
    )
}
export default SavestatusChecker;